import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";

import Layout from "layouts/DashboardManage";
import Pagination from "components/Pagination";
import ManageDataTable from "components/ManageDataTable";
import Notification from "components/Notification";
import { getAllDeletedFiles } from "store/actions/fileAction";
import { SpinnerRainbow } from "components/Spinner";
import NoData from "components/NoData";
import Translate from "helpers/Translate";
import SearchFilters from "./searchFilter";
import FileDetails from "../FileHistory/FileDetails";

// Styles
import "./deletedFilesLogs.scss";

const DeletedFileLogs = () => {
  const dispatch = useDispatch();
  const isLoadingDeletedFile = useSelector(
    state => state.file.isLoadingDeletedFile
  );
  const allDeletedFiles = useSelector(state => state.file.getDeletedFiles);

  const [selectedOriginalFilename, setSelectedOriginalFilename] = useState("");
  const [selectedPageLimit, setSelectedPageLimit] = useState(10);

  // Get file list
  useEffect(() => {
    dispatch(getAllDeletedFiles({}));
    // eslint-disable-next-line
  }, [dispatch]);
  const handleFilterData = ({ page = 1, resetFilter }) => {
    dispatch(
      getAllDeletedFiles({
        rawFilename: !resetFilter ? selectedOriginalFilename : "",
        page,
        limit: !resetFilter ? selectedPageLimit : 10
      })
    );
  };
  const handleResetFilter = () => {
    Notification.confirm(Translate({ id: "sure_to_reset" }), {
      onOk: () => {
        setSelectedOriginalFilename("");
        setSelectedPageLimit("");

        handleFilterData({
          resetFilter: true
        });
      },
      labelOk: Translate({ id: "yes" }),
      labelCancel: Translate({ id: "no" })
    });
  };
  const onPageChange = data => {
    const targetPage = parseInt(data.selected) + 1;
    handleFilterData({ page: targetPage });
  };

  const hasData = () => {
    return (
      !isLoadingDeletedFile &&
      allDeletedFiles?.data &&
      allDeletedFiles.data.length > 0
    );
  };
  const getFileDeletionDate = item => {
    let deletionDate = "--";

    if (item?.deleted_at) {
      deletionDate = moment(item.deleted_at).format("YYYY-MM-DD H:m");
    }
    return deletionDate;
  };
  return (
    <Layout>
      <div className="manage">
        <Link className="back mb-20" to="/manage">
          <i className="fas fa-long-arrow-alt-left"></i>
          {Translate({ id: "back_to_manage_dashboard" })}
        </Link>
        <div className="manage-page-heading">
          <span className="manage-page-icon tone-red" aria-hidden="true">
            <i className="fas fa-trash"></i>
          </span>
          <div className="manage-page-heading__text">
            <h1 className="title">{Translate({ id: "deleted_file_logs" })}</h1>
            <p className="manage-page-subtitle">
              {Translate({ id: "deleted_file_logs_description" })}
            </p>
          </div>
        </div>

        {/* Filters */}
        <h4 className="mb-5">{Translate({ id: "filters" })}:</h4>
        <div className="file-deleted__filters mb-20">
          <SearchFilters
            handleFilterData={handleFilterData}
            handleResetFilter={handleResetFilter}
            selectedOriginalFilename={selectedOriginalFilename}
            setSelectedOriginalFilename={setSelectedOriginalFilename}
            selectedPageLimit={selectedPageLimit}
            setSelectedPageLimit={setSelectedPageLimit}
          />
        </div>

        {isLoadingDeletedFile && <SpinnerRainbow />}

        {!isLoadingDeletedFile && (
          <ManageDataTable
            footer={
              hasData() ? (
                <Pagination
                  onPageChange={onPageChange}
                  data={allDeletedFiles && allDeletedFiles.meta}
                />
              ) : null
            }
          >
            <table className="file-deleted">
              <thead>
                <tr>
                  <th className="left">{Translate({ id: "file_id" })} </th>
                  <th className="left">
                    {Translate({ id: "original_filename" })}
                  </th>
                  <th className="left">{Translate({ id: "deleted_by" })} </th>
                  <th className="left">{Translate({ id: "client_name" })} </th>
                  <th className="left">
                    {Translate({ id: "collection_item_value" })}
                  </th>
                  <th className="left">
                    {Translate({ id: "date_of_file_deletion" })}
                  </th>
                  <th className="action-col">
                    {Translate({ id: "action" })}
                  </th>
                </tr>
              </thead>

              <tbody>
                {hasData() &&
                  allDeletedFiles?.data?.map(item => (
                    <tr key={item.id}>
                      <td>{item.eisenlens_filename}</td>
                      <td>{item.raw_filename}</td>
                      <td>{item.deleted_by?.fullname}</td>
                      <td>{item.client?.name}</td>
                      <td>{item.department_item_value}</td>
                      <td>{getFileDeletionDate(item)}</td>
                      <td className="action-col">
                        <div className="manage-data-table-actions">
                          <FileDetails fileDoc={item} />
                        </div>
                      </td>
                    </tr>
                  ))}

                {!hasData() && (
                  <tr>
                    <td colSpan="100">
                      <NoData />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </ManageDataTable>
        )}
      </div>
    </Layout>
  );
};
export default DeletedFileLogs;
